<template>
  <div class="hidden lg:block w-9/12 m-auto">
    <header>
      <div class="px-5 py-2 bg-white flex items-center ">
        <form @submit.prevent="submitSearch" class="w-full">

            <!-- search -->
            <div class="flex items-center justify-start rounded-md  p-2 mt-2 mb-1 border-gray-500">
              <label :for="search.name" class="mr-2 text-gray-500">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill:rgba(0, 0, 0, 1);transform:;-ms-filter:"><path d="M10,18c1.846,0,3.543-0.635,4.897-1.688l4.396,4.396l1.414-1.414l-4.396-4.396C17.365,13.543,18,11.846,18,10 c0-4.411-3.589-8-8-8s-8,3.589-8,8S5.589,18,10,18z M10,4c3.309,0,6,2.691,6,6s-2.691,6-6,6s-6-2.691-6-6S6.691,4,10,4z"></path><path d="M11.412,8.586C11.791,8.966,12,9.468,12,10h2c0-1.065-0.416-2.069-1.174-2.828c-1.514-1.512-4.139-1.512-5.652,0 l1.412,1.416C9.346,7.83,10.656,7.832,11.412,8.586z"></path></svg></label>
              <input class="flex-auto placeholder-gray-500 focus:placeholder-gray-300" type="text" :name="search.name"  :placeholder="search.name" v-model.trim="search.val">
              <button type="button" class="mr-1 bg-blue-700 hover:bg-blue-900  rounded-md shadow-sm overflow-hidden text-white p-2 px-4 text-sm font-bold">
                Search
              </button>
            </div>

        </form>
        <router-link class="text-blue-800 mx-4 flex items-center justify-center" to="/cart">
          <svg xmlns="http://www.w3.org/2000/svg" class="h-6" viewBox="0 0 24 24" style="fill:currentColor;transform:-ms-filter:"><path fill="none" d="M8.246 11L18.246 11 19.675 6 6.428 6z"></path><path d="M21,4H5H4H2v2h2h0.3l3.282,9.025C8.011,16.206,9.145,17,10.401,17H19v-2h-8.599c-0.419,0-0.797-0.265-0.94-0.658L8.973,13 h9.273c0.89,0,1.68-0.598,1.923-1.451l1.793-6.274c0.086-0.302,0.025-0.626-0.163-0.877C21.609,4.147,21.313,4,21,4z M18.246,11 h-10L6.428,6h13.247L18.246,11z"></path><circle cx="10.5" cy="19.5" r="1.5"></circle><circle cx="16.5" cy="19.5" r="1.5"></circle></svg>
          <span class="font-bold ml-2">Cart</span>
        </router-link>
        <router-link class="text-blue-800 mx-4 flex items-center justify-center" to="/purchases" v-if="auth.userId">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill:currentColor;transform:-ms-filter:"><path d="M5,22h14c1.103,0,2-0.897,2-2V9c0-0.553-0.447-1-1-1h-3V7c0-2.757-2.243-5-5-5S7,4.243,7,7v1H4C3.447,8,3,8.447,3,9v11 C3,21.103,3.897,22,5,22z M9,7c0-1.654,1.346-3,3-3s3,1.346,3,3v1H9V7z M5,10h2v2h2v-2h6v2h2v-2h2l0.002,10H5V10z"></path></svg>
          <span class="font-bold ml-2">Purchases</span>
        </router-link>
      </div>
    </header>
    <div class="grid grid-cols-6 gap-1 my-5">
      <aside class="col-span-1">
        <div class="p-2 text-left w-full">
         <div class="flex items-center justify-start">
           <span>
             <svg xmlns="http://www.w3.org/2000/svg" class="h-5" viewBox="0 0 24 24" style="fill:currentColor;transform:;-ms-filter:"><path d="M21,3H5C4.447,3,4,3.447,4,4v2.59c0,0.523,0.213,1.037,0.583,1.407L10,13.414V21c0,0.347,0.18,0.668,0.475,0.851 C10.635,21.95,10.817,22,11,22c0.153,0,0.306-0.035,0.447-0.105l4-2C15.786,19.725,16,19.379,16,19v-5.586l5.417-5.417 C21.787,7.627,22,7.113,22,6.59V4C22,3.447,21.553,3,21,3z M14.293,12.293C14.105,12.48,14,12.734,14,13v5.382l-2,1V13 c0-0.266-0.105-0.52-0.293-0.707L6,6.59V5h14.001l0.002,1.583L14.293,12.293z"></path></svg>
           </span>
           <h1 class="ml-4 font-bold">Search Filter</h1>
         </div>
         <!-- Shipment Availability -->
         <div class="py-4 border-b">
           <h2 class="text-gray-800 mb-2">Shipment Access</h2>
           <label class="block m-1 text-sm"><input type="checkbox" name="shipment" id="" class="mr-2">International</label>
           <label class="block m-1 text-sm"><input type="checkbox" name="shipment" id="" class="mr-2">Local</label>
         </div>
         <!-- Shipment Availability -->
         <div class="py-4 border-b">
           <h2 class="text-gray-800 mb-2">Shipment From</h2>
           <label class="block m-1 text-sm"><input type="checkbox" name="shipment" id="" class="mr-2">Abu Dhabi</label>
           <label class="block m-1 text-sm"><input type="checkbox" name="shipment" id="" class="mr-2">Ajman</label>
           <label class="block m-1 text-sm"><input type="checkbox" name="shipment" id="" class="mr-2">Dubai</label>
           <label class="block m-1 text-sm"><input type="checkbox" name="shipment" id="" class="mr-2">Fujairah</label>
           <label class="block m-1 text-sm"><input type="checkbox" name="shipment" id="" class="mr-2">Ras Al Khaimah</label>
           <label class="block m-1 text-sm"><input type="checkbox" name="shipment" id="" class="mr-2">Sharjah</label>
           <label class="block m-1 text-sm"><input type="checkbox" name="shipment" id="" class="mr-2">Umm Al Quwain</label>
         </div>
          <!-- Shipment Option -->
         <div class="py-4 border-b">
           <h2 class="text-gray-800 mb-2">Shipping Option</h2>
           <label class="block m-1 text-sm"><input type="checkbox" name="shipment" id="" class="mr-2">Standard Delivery (SPX)</label>
           <label class="block m-1 text-sm"><input type="checkbox" name="shipment" id="" class="mr-2">J&T Express</label>
           <label class="block m-1 text-sm"><input type="checkbox" name="shipment" id="" class="mr-2">GoGo Express</label>
           <label class="block m-1 text-sm"><input type="checkbox" name="shipment" id="" class="mr-2">LBC Express</label>
           <label class="block m-1 text-sm"><input type="checkbox" name="shipment" id="" class="mr-2">2GO Integrated</label>
           <label class="block m-1 text-sm"><input type="checkbox" name="shipment" id="" class="mr-2">Ninja Van</label>
           <label class="block m-1 text-sm"><input type="checkbox" name="shipment" id="" class="mr-2">LogiXtics</label>
         </div>
        <!-- Price Range -->
         <div class="py-4 border-b">
            <h2 class="text-gray-800 mb-2">Price Range</h2>
            <input type="text" placeholder="MIN" class="w-full rounded-md shadow-sm overflow-hidden mb-1 p-2 pr-4 text-sm text-right">
            <input type="text" placeholder="MAX" class="w-full rounded-md shadow-sm overflow-hidden mb-1 p-2 pr-4 text-sm text-right">
            <button class="mt-1 bg-blue-700 hover:bg-blue-900  rounded-md shadow-sm overflow-hidden text-white p-2 w-full text-sm font-bold"> Apply </button>
         </div>
        <!-- Ratings -->
         <div class="py-4 border-b">
           <h2 class="text-gray-800 mb-2">Ratings</h2>
           <button class="my-1 flex items-center justify-start text-yellow-400 hover:text-yellow-500">
              <span v-for="count in 5" :key="count">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-5" viewBox="0 0 24 24" style="fill:currentColor;transform:;-ms-filter:"><path d="M21.947,9.179c-0.129-0.378-0.47-0.645-0.868-0.676L15.378,8.05l-2.467-5.461C12.75,2.23,12.393,2,12,2 s-0.75,0.23-0.911,0.588L8.622,8.05L2.921,8.503C2.53,8.534,2.193,8.791,2.06,9.16s-0.039,0.782,0.242,1.056l4.213,4.107 l-1.49,6.452c-0.092,0.399,0.069,0.814,0.406,1.047C5.603,21.94,5.801,22,6,22c0.193,0,0.387-0.056,0.555-0.168L12,18.202 l5.445,3.63c0.348,0.232,0.805,0.223,1.145-0.024c0.338-0.247,0.487-0.68,0.372-1.082l-1.829-6.4l4.536-4.082 C21.966,9.976,22.075,9.558,21.947,9.179z"></path></svg>
              </span>
           </button>
           <button class="my-1 flex items-center justify-start text-yellow-400 hover:text-yellow-500">
              <span v-for="count in 4" :key="count">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-5" viewBox="0 0 24 24" style="fill:currentColor;transform:;-ms-filter:"><path d="M21.947,9.179c-0.129-0.378-0.47-0.645-0.868-0.676L15.378,8.05l-2.467-5.461C12.75,2.23,12.393,2,12,2 s-0.75,0.23-0.911,0.588L8.622,8.05L2.921,8.503C2.53,8.534,2.193,8.791,2.06,9.16s-0.039,0.782,0.242,1.056l4.213,4.107 l-1.49,6.452c-0.092,0.399,0.069,0.814,0.406,1.047C5.603,21.94,5.801,22,6,22c0.193,0,0.387-0.056,0.555-0.168L12,18.202 l5.445,3.63c0.348,0.232,0.805,0.223,1.145-0.024c0.338-0.247,0.487-0.68,0.372-1.082l-1.829-6.4l4.536-4.082 C21.966,9.976,22.075,9.558,21.947,9.179z"></path></svg>
              </span>
              <span>
                <svg xmlns="http://www.w3.org/2000/svg" class="h-5 text-gray-300" viewBox="0 0 24 24" style="fill:currentColor;transform:;-ms-filter:"><path d="M21.947,9.179c-0.129-0.378-0.47-0.645-0.868-0.676L15.378,8.05l-2.467-5.461C12.75,2.23,12.393,2,12,2 s-0.75,0.23-0.911,0.588L8.622,8.05L2.921,8.503C2.53,8.534,2.193,8.791,2.06,9.16s-0.039,0.782,0.242,1.056l4.213,4.107 l-1.49,6.452c-0.092,0.399,0.069,0.814,0.406,1.047C5.603,21.94,5.801,22,6,22c0.193,0,0.387-0.056,0.555-0.168L12,18.202 l5.445,3.63c0.348,0.232,0.805,0.223,1.145-0.024c0.338-0.247,0.487-0.68,0.372-1.082l-1.829-6.4l4.536-4.082 C21.966,9.976,22.075,9.558,21.947,9.179z"></path></svg>
              </span>
              <span class="text-sm text-gray-600 ml-1">&amp; Up</span>
           </button>
           <button class="my-1 flex items-center justify-start text-yellow-400 hover:text-yellow-500">
              <span v-for="count in 3" :key="count">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-5" viewBox="0 0 24 24" style="fill:currentColor;transform:;-ms-filter:"><path d="M21.947,9.179c-0.129-0.378-0.47-0.645-0.868-0.676L15.378,8.05l-2.467-5.461C12.75,2.23,12.393,2,12,2 s-0.75,0.23-0.911,0.588L8.622,8.05L2.921,8.503C2.53,8.534,2.193,8.791,2.06,9.16s-0.039,0.782,0.242,1.056l4.213,4.107 l-1.49,6.452c-0.092,0.399,0.069,0.814,0.406,1.047C5.603,21.94,5.801,22,6,22c0.193,0,0.387-0.056,0.555-0.168L12,18.202 l5.445,3.63c0.348,0.232,0.805,0.223,1.145-0.024c0.338-0.247,0.487-0.68,0.372-1.082l-1.829-6.4l4.536-4.082 C21.966,9.976,22.075,9.558,21.947,9.179z"></path></svg>
              </span>
              <span v-for="count in 2" :key="count">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-5 text-gray-300" viewBox="0 0 24 24" style="fill:currentColor;transform:;-ms-filter:"><path d="M21.947,9.179c-0.129-0.378-0.47-0.645-0.868-0.676L15.378,8.05l-2.467-5.461C12.75,2.23,12.393,2,12,2 s-0.75,0.23-0.911,0.588L8.622,8.05L2.921,8.503C2.53,8.534,2.193,8.791,2.06,9.16s-0.039,0.782,0.242,1.056l4.213,4.107 l-1.49,6.452c-0.092,0.399,0.069,0.814,0.406,1.047C5.603,21.94,5.801,22,6,22c0.193,0,0.387-0.056,0.555-0.168L12,18.202 l5.445,3.63c0.348,0.232,0.805,0.223,1.145-0.024c0.338-0.247,0.487-0.68,0.372-1.082l-1.829-6.4l4.536-4.082 C21.966,9.976,22.075,9.558,21.947,9.179z"></path></svg>
              </span>
              <span class="text-sm text-gray-600 ml-1">&amp; Up</span>
           </button>
           <button class="my-1 flex items-center justify-start text-yellow-400 hover:text-yellow-500">
              <span v-for="count in 2" :key="count">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-5" viewBox="0 0 24 24" style="fill:currentColor;transform:;-ms-filter:"><path d="M21.947,9.179c-0.129-0.378-0.47-0.645-0.868-0.676L15.378,8.05l-2.467-5.461C12.75,2.23,12.393,2,12,2 s-0.75,0.23-0.911,0.588L8.622,8.05L2.921,8.503C2.53,8.534,2.193,8.791,2.06,9.16s-0.039,0.782,0.242,1.056l4.213,4.107 l-1.49,6.452c-0.092,0.399,0.069,0.814,0.406,1.047C5.603,21.94,5.801,22,6,22c0.193,0,0.387-0.056,0.555-0.168L12,18.202 l5.445,3.63c0.348,0.232,0.805,0.223,1.145-0.024c0.338-0.247,0.487-0.68,0.372-1.082l-1.829-6.4l4.536-4.082 C21.966,9.976,22.075,9.558,21.947,9.179z"></path></svg>
              </span>
              <span v-for="count in 3" :key="count">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-5 text-gray-300" viewBox="0 0 24 24" style="fill:currentColor;transform:;-ms-filter:"><path d="M21.947,9.179c-0.129-0.378-0.47-0.645-0.868-0.676L15.378,8.05l-2.467-5.461C12.75,2.23,12.393,2,12,2 s-0.75,0.23-0.911,0.588L8.622,8.05L2.921,8.503C2.53,8.534,2.193,8.791,2.06,9.16s-0.039,0.782,0.242,1.056l4.213,4.107 l-1.49,6.452c-0.092,0.399,0.069,0.814,0.406,1.047C5.603,21.94,5.801,22,6,22c0.193,0,0.387-0.056,0.555-0.168L12,18.202 l5.445,3.63c0.348,0.232,0.805,0.223,1.145-0.024c0.338-0.247,0.487-0.68,0.372-1.082l-1.829-6.4l4.536-4.082 C21.966,9.976,22.075,9.558,21.947,9.179z"></path></svg>
              </span>
              <span class="text-sm text-gray-600 ml-1">&amp; Up</span>
           </button>
           <button class="my-1 flex items-center justify-start text-yellow-400 hover:text-yellow-500">
              <span v-for="count in 1" :key="count">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-5" viewBox="0 0 24 24" style="fill:currentColor;transform:;-ms-filter:"><path d="M21.947,9.179c-0.129-0.378-0.47-0.645-0.868-0.676L15.378,8.05l-2.467-5.461C12.75,2.23,12.393,2,12,2 s-0.75,0.23-0.911,0.588L8.622,8.05L2.921,8.503C2.53,8.534,2.193,8.791,2.06,9.16s-0.039,0.782,0.242,1.056l4.213,4.107 l-1.49,6.452c-0.092,0.399,0.069,0.814,0.406,1.047C5.603,21.94,5.801,22,6,22c0.193,0,0.387-0.056,0.555-0.168L12,18.202 l5.445,3.63c0.348,0.232,0.805,0.223,1.145-0.024c0.338-0.247,0.487-0.68,0.372-1.082l-1.829-6.4l4.536-4.082 C21.966,9.976,22.075,9.558,21.947,9.179z"></path></svg>
              </span>
              <span v-for="count in 4" :key="count">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-5 text-gray-300" viewBox="0 0 24 24" style="fill:currentColor;transform:;-ms-filter:"><path d="M21.947,9.179c-0.129-0.378-0.47-0.645-0.868-0.676L15.378,8.05l-2.467-5.461C12.75,2.23,12.393,2,12,2 s-0.75,0.23-0.911,0.588L8.622,8.05L2.921,8.503C2.53,8.534,2.193,8.791,2.06,9.16s-0.039,0.782,0.242,1.056l4.213,4.107 l-1.49,6.452c-0.092,0.399,0.069,0.814,0.406,1.047C5.603,21.94,5.801,22,6,22c0.193,0,0.387-0.056,0.555-0.168L12,18.202 l5.445,3.63c0.348,0.232,0.805,0.223,1.145-0.024c0.338-0.247,0.487-0.68,0.372-1.082l-1.829-6.4l4.536-4.082 C21.966,9.976,22.075,9.558,21.947,9.179z"></path></svg>
              </span>
              <span class="text-sm text-gray-600 ml-1">&amp; Up</span>
           </button>
         </div>
         <!-- Services & Promotion -->
         <div class="py-4 border-b">
           <h2 class="text-gray-800 mb-2">Discounts & Promotions</h2>
           <label class="block m-1 text-sm"><input type="checkbox" name="shipment" id="" class="mr-2">Discounted</label>
           <label class="block m-1 text-sm"><input type="checkbox" name="shipment" id="" class="mr-2">Free Shipping</label>
           <label class="block m-1 text-sm"><input type="checkbox" name="shipment" id="" class="mr-2">Voucher</label>
           <label class="block m-1 text-sm"><input type="checkbox" name="shipment" id="" class="mr-2">Wholesale</label>
           <label class="block m-1 text-sm"><input type="checkbox" name="shipment" id="" class="mr-2">Promo Code</label>
         </div>

        <button class="bg-blue-700 hover:bg-blue-900  rounded-md shadow-sm overflow-hidden text-white p-2 mt-2 mb-4 w-full text-sm font-bold"> Clear Search </button>
        </div>
      </aside>
      <main class="col-span-5">
        <div class="py-3 flex items-center justify-between">
          <div class="flex items-center justify-between">
            <p class="text-sm mr-2">Sort by</p>
              <button type="button" class="mr-1 min-width-btn bg-blue-700 hover:bg-blue-900 shadow-sm overflow-hidden text-white p-2 text-sm">
                Newest
              </button>
              <button type="button" class="mr-1 min-width-btn bg-gray-50 hover:bg-white shadow-sm overflow-hidden text-gray-700 p-2 text-sm ">
                Trending
              </button>
              <button type="button" class="mr-1 min-width-btn bg-gray-50 hover:bg-white shadow-sm overflow-hidden text-gray-700 p-2 text-sm ">
                Top Sales
              </button>

              <div class="relative min-width-btn w-36 bg-white p-2 text-sm">
                <div class="flex items-center justify-between" @click.prevent="price.show = ! price.show" >
                  <p>Price</p>
                  <div class="pointer-events-auto">
                    <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"></path></svg>
                  </div>
                </div>
                <div class="z-20 absolute left-0 top-9 bg-white w-full text-left" v-if="price.show" >
                  <button type="button" class="w-full min-width-btn bg-gray-50 hover:bg-white shadow-sm overflow-hidden text-gray-700 p-2 py-3 text-sm ">
                    Lowest to Highest
                  </button>
                  <button type="button" class="w-full min-width-btn bg-gray-50 hover:bg-white shadow-sm overflow-hidden text-gray-700 p-2 py-3 text-sm ">
                    Highest to Lowest  
                  </button>
                </div>
              </div>
          </div>
          <div class="flex items-center justify-end">
              <p class="text-sm mx-4"><span class="text-blue-500 font-bold">1</span> / 3 </p>
              <button type="button" class="bg-gray-200 shadow-sm overflow-hidden text-gray-700 p-2 text-sm ">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-5" viewBox="0 0 24 24" style="fill:rgba(0, 0, 0, 1);transform:;-ms-filter:"><path d="M13.293 6.293L7.586 12 13.293 17.707 14.707 16.293 10.414 12 14.707 7.707z"></path></svg>
              </button>

              <button type="button" class="bg-gray-50 hover:bg-white shadow-sm overflow-hidden text-gray-700 p-2 text-sm ">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-5" viewBox="0 0 24 24" style="fill:rgba(0, 0, 0, 1);transform:;-ms-filter:"><path d="M10.707 17.707L16.414 12 10.707 6.293 9.293 7.707 13.586 12 9.293 16.293z"></path></svg>
              </button>
          </div>
        </div>
        <div class="py-2 mt-1">
          <!-- {{productList}} -->
          <div class="grid grid-cols-5 gap-2">
              <div class="bg-white w-full h-72 shadow-md relative" v-for="item in productList" :key="item" @click="showDemoDialogue = true ">
                <div class="absolute bg-red-700 shadow-md right-0 text-sm text-white px-2 p-1" v-if="item.selected">{{ item.discount }}%</div>
                <img  class="object-cover h-44" :src="item.src">
                <figure class="text-sm p-3 text-left">
                  <h1 class="max-lines text-sm" >Lorem ipsum dolor sit amet consectetur, adipisicing eli {{count}}</h1>
                  <h2 class="text-base text-yellow-600">
                    <span :class=" item.selected ? 'text-xs line-through mr-2':'' ">{{ item.price }}</span>
                    <span v-if="item.selected">{{ discountedPrice(item.price, item.discount) }}</span>
                    Dhs.
                  </h2>
                  <div class="my-1 flex items-center justify-between">
                    <button>
                      <svg xmlns="http://www.w3.org/2000/svg" class="h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1" d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
                      </svg>
                    </button>
                    
                    <span class="text-yellow-500 flex items-center" v-if="item.star && item.star > 1">
                      <span class="text-base">{{ item.star }}</span>
                      <svg xmlns="http://www.w3.org/2000/svg" class="ml-1 h-4" viewBox="0 0 24 24" style="fill:currentColor;transform:;-ms-filter:"><path d="M21.947,9.179c-0.129-0.378-0.47-0.645-0.868-0.676L15.378,8.05l-2.467-5.461C12.75,2.23,12.393,2,12,2 s-0.75,0.23-0.911,0.588L8.622,8.05L2.921,8.503C2.53,8.534,2.193,8.791,2.06,9.16s-0.039,0.782,0.242,1.056l4.213,4.107 l-1.49,6.452c-0.092,0.399,0.069,0.814,0.406,1.047C5.603,21.94,5.801,22,6,22c0.193,0,0.387-0.056,0.555-0.168L12,18.202 l5.445,3.63c0.348,0.232,0.805,0.223,1.145-0.024c0.338-0.247,0.487-0.68,0.372-1.082l-1.829-6.4l4.536-4.082 C21.966,9.976,22.075,9.558,21.947,9.179z"></path></svg>
                    </span>

                    <span class="text-gray-500 flex items-center" v-else>
                      <span class="text-xs">No Ratings Yet</span>
                    </span>

                  </div>
                </figure>
              </div> 
          </div>
          <div class="mt-10 flex items-center justify-center">
            <button type="button" class="mr-1 bg-gray-200 shadow-sm overflow-hidden text-gray-700 p-2 text-sm ">
              <svg xmlns="http://www.w3.org/2000/svg" class="h-5" viewBox="0 0 24 24" style="fill:rgba(0, 0, 0, 1);transform:;-ms-filter:"><path d="M13.293 6.293L7.586 12 13.293 17.707 14.707 16.293 10.414 12 14.707 7.707z"></path></svg>
            </button>
            <p class="text-sm mx-4"><span class="text-blue-500 font-bold">1</span> / 3 </p>
            <button type="button" class="mr-1 bg-gray-50 hover:bg-white shadow-sm overflow-hidden text-gray-700 p-2 text-sm ">
              <svg xmlns="http://www.w3.org/2000/svg" class="h-5" viewBox="0 0 24 24" style="fill:rgba(0, 0, 0, 1);transform:;-ms-filter:"><path d="M10.707 17.707L16.414 12 10.707 6.293 9.293 7.707 13.586 12 9.293 16.293z"></path></svg>
            </button>
          </div>
        </div>
      </main>
    </div>
    <footer>
      <p class="my-5 mt-10 text-gray-400 text-sm" v-html="pageContent.copyright"></p>
    </footer>  
  </div>  


  <!-- smaller devices -->
  <div class="lg:hidden flex items-center flex-col">
    <svg xmlns="http://www.w3.org/2000/svg" class="h-14" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1" d="M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
    </svg>
    <p class="px-5 pt-2"> The current version of application doesn't support smaller devices yet. For the time being, kindly open this in bigger screen.</p> 
  </div>
</template>

<script>
import { ref } from 'vue';
import { useStore } from 'vuex';
import { computed } from 'vue';

export default {

  setup() {

    const randSelect = () => ((Math.floor(Math.random() * 10) + 1) % 4 === 0);
    const randStar = () => ((Math.random() * 5).toFixed(1));
    const discount = () => Math.round(Math.random() * 80  + 1);
    const basePrice = (count) => (count * Math.random() * ( 35 - 25 ) + 25).toFixed(2);


    const showDemoDialogue = ref(false);
    const store = useStore();

    const discountedPrice = (price, discount) => (price - (price * (discount / 100))).toFixed(2);

    const pageContent = computed(() => store.getters.pageContent );

    const auth = computed(() => store.getters["authModule/auth"] );

    let productItem = {
      selected: "",
      star: "",
      discount: "",
      price: "",
      src: "",
    }

    const productList = [];

    function generateProduct(){
      return new Promise (resolve =>{
        for(let i = 0; i < 50; i++){
          productItem.selected = randSelect();
          productItem.discount = discount();
          productItem.star = randStar();
          productItem.price = basePrice(i);
          productItem.src = "https://picsum.photos/600/400?image-36"+i;
          productList.push(productItem);
          productItem = {};
        }
        resolve(true);
      });
    }

    generateProduct();

    const search = ref({
      name:"Search items here...",
      val:"",
      err:"",
    });

    const price = ref({
      show: false,
    })

      return {
        search, price, discountedPrice, auth, productList, pageContent, showDemoDialogue
      }
  }
}
</script>

<style>
.max-lines {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2; /* number of lines to show */
  -webkit-box-orient: vertical;

  /* display: block;or inline-block */
  /* text-overflow: ellipsis; */
  /* word-wrap: break-word; */
  /* overflow: hidden; */
  /* max-height: 2.6em; */
  /* line-height: 1.8em; */
}

.-bottom-26 {
  bottom: -6.75rem/* -96px */;
}

.min-width-btn{
  min-width: 100px;
}
/* <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill:rgba(0, 0, 0, 1);transform:;-ms-filter:"><path d="M20.205,4.791c-1.137-1.131-2.631-1.754-4.209-1.754c-1.483,0-2.892,0.552-3.996,1.558 c-1.104-1.006-2.512-1.558-3.996-1.558c-1.578,0-3.072,0.623-4.213,1.758c-2.353,2.363-2.352,6.059,0.002,8.412L12,21.414 l8.207-8.207C22.561,10.854,22.562,7.158,20.205,4.791z"></path></svg> */
</style>